import { Monitor, Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/shared/ui/button';
import { useThemeStore, type ThemeMode } from '@/stores/themeStore';

const ORDER: ReadonlyArray<ThemeMode> = ['light', 'dark', 'system'];

export function ThemeToggle(): JSX.Element {
  const { t } = useTranslation();
  const mode = useThemeStore((s) => s.mode);
  const setMode = useThemeStore((s) => s.setMode);

  const onClickToggleTheme = (): void => {
    const next_index = (ORDER.indexOf(mode) + 1) % ORDER.length;
    setMode(ORDER[next_index] ?? 'system');
  };

  const Icon = mode === 'dark' ? Moon : mode === 'light' ? Sun : Monitor;

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      onClick={onClickToggleTheme}
      aria-label={t('layout.toggle_theme')}
      title={t(`layout.theme_${mode}`)}
    >
      <Icon className="h-4 w-4" aria-hidden />
    </Button>
  );
}
